import {
  resolveInvestorOnboardingFlow,
  getNextOnboardingStep,
  isOnboardingComplete,
} from "../config/investorOnboarding/defaultInvestorOnboardingFlow";
import { withInvestorQuery } from "./investorRouteHelpers";

export function resolvePostInvestorAuthPath(session, queryParams = {}, companySettings = null) {
  const flow = resolveInvestorOnboardingFlow(companySettings);
  const progress = session?.onboarding_progress || {};

  const next = getNextOnboardingStep(flow, progress);
  if (next && next.id !== "account") {
    return withInvestorQuery(next.route, queryParams);
  }

  if (queryParams.redirect) {
    return withInvestorQuery(queryParams.redirect, queryParams);
  }

  return "/invest/dashboard";
}

export { isOnboardingComplete, getNextOnboardingStep, resolveInvestorOnboardingFlow };
